import { render } from "./ResourcesSearchBar.vue?vue&type=template&id=083b2651&scoped=true"
import script from "./ResourcesSearchBar.vue?vue&type=script&lang=js"
export * from "./ResourcesSearchBar.vue?vue&type=script&lang=js"

import "./ResourcesSearchBar.vue?vue&type=style&index=0&id=083b2651&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083b2651"]])

export default __exports__